import { InputHTMLAttributes, forwardRef } from 'react';
import { classNames } from '@/utils/classNames';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className, ...props }, ref) => {
    const inputClasses = classNames(
      'block w-full rounded-md border-2 border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm bg-white dark:border-gray-500 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-primary-500 dark:focus:ring-primary-500 px-3 py-2',
      error &&
        'border-red-300 text-red-900 placeholder-red-300 focus:border-red-500 focus:ring-red-500 dark:border-red-500 dark:text-red-100 dark:placeholder-red-400',
      props.disabled &&
        'bg-gray-50 text-gray-500 cursor-not-allowed dark:bg-gray-600 dark:text-gray-400 dark:border-gray-600',
      className
    );

    return (
      <div className='space-y-1'>
        {label && (
          <label
            className={classNames(
              'block text-sm font-medium',
              error ? 'text-red-700 dark:text-red-400' : 'text-gray-700 dark:text-gray-300'
            )}
          >
            {label}
            {props.required && <span className='text-red-500 ml-1'>*</span>}
          </label>
        )}
        <input ref={ref} className={inputClasses} {...props} />
        {error && <p className='text-sm text-red-600 dark:text-red-400'>{error}</p>}
        {helperText && !error && (
          <p className='text-sm text-gray-500 dark:text-gray-400'>{helperText}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
